import apiClient from './axiosInstanceItem';

export const createItem = async (itemData) => {
  return await apiClient.post('/item/upsert', itemData);
};

export const getItemData = async (tripId, stockNo) => {
  return await apiClient.get(`/getitemdata/${tripId}/${stockNo}`);
};

export const getItemDataCount = async (tripId, stockNo) => {
  return await apiClient.get(`/datacounts/${tripId}/${stockNo}`);
};

export const getTrackingData = async (tripId, stockNo) => {
  return await apiClient.get(`/tracking/${tripId}/${stockNo}`);
};

export const getItemDataUsingQrCode = async (qrcode) => {
  return await apiClient.get(`/item/qr/${qrcode}`);
};

